var comparisonScrollActions = function () {
  jQuery(window).scroll(function () {
    var topDiv = (jQuery('.feature-comparison-container').offset() || { 'top': NaN }).top - jQuery(window).height();
    var bottomDiv = (jQuery('.comparison-price-wrapper .other-pricing').offset() || { 'top': NaN }).top - jQuery(window).height();

    if (jQuery(this).scrollTop() > topDiv) {
      jQuery('.feature-price-mob').addClass('active');
    } else {
      jQuery('.feature-price-mob').removeClass('active');
    }

    if (jQuery(this).scrollTop() > bottomDiv) {
      jQuery('.feature-price-mob').removeClass('active');
    }
  });

  jQuery('.feature-comparison-widget').on('click', function (ev) {
    jQuery(this).toggleClass('active');
  });
};

export { comparisonScrollActions };
